import { render, staticRenderFns } from "./autoCompleteFornecedor.vue?vue&type=template&id=28dd20b0&scoped=true"
import script from "./autoCompleteFornecedor.vue?vue&type=script&lang=js"
export * from "./autoCompleteFornecedor.vue?vue&type=script&lang=js"
import style0 from "./autoCompleteFornecedor.vue?vue&type=style&index=0&id=28dd20b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd20b0",
  null
  
)

export default component.exports